import React from "react";
import { Navigate } from "react-router-dom";

const GuestMiddleware = (props) => {
    if (localStorage.getItem("authUser")) {
        return (
            <Navigate to={{ pathname: "/dashboard" }} />
        );
    }
    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};

export default GuestMiddleware;
